<template>
  <div class="container">
    <van-loading v-if="loading" class="loading" />
    <div v-else class="content">
      <!-- 企业基本信息卡片 -->
      <div class="card info-card">
        <div class="card-title">
          <van-icon name="info-o" size="18" color="#4892FB" />
          <span>企业基本信息</span>
        </div>
        <div class="info-list">
          <div class="info-item">
            <span class="label">企业名称</span>
            <span class="value">{{ info.enterpriseName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">企业地址</span>
            <span class="value">{{ info.enterpriseAddress || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">法人代表</span>
            <span class="value">{{ info.legal || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">联系电话</span>
            <span class="value">{{ info.legalPhone || '-' }}</span>
          </div>
          <!-- <div class="info-item">
            <span class="label">入驻时间</span>
            <span class="value">{{ formatDate(info.rtime) }}</span>
          </div> -->
          <div class="info-item">
            <span class="label">营业执照号</span>
            <span class="value">{{ info.businessLicense || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 营业执照附件 -->
      <div class="card license-card">
        <div class="card-title">
          <van-icon name="description" size="18" color="#4892FB" />
          <span>营业执照</span>
        </div>
        <div class="license-list" v-if="licenseFiles.length > 0">
          <a
            class="license-item"
            v-for="(file, index) in licenseFiles"
            :key="index"
            :href="file.url"
          >
            <div class="file-icon">
              <van-icon name="description" size="24" color="#4892FB" />
            </div>
            <div class="file-info">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-hint">点击下载查看</div>
            </div>
            <div class="file-arrow">
              <van-icon name="arrow" size="16" color="#999" />
            </div>
          </a>
        </div>
        <div v-else class="empty-license">
          <van-icon name="info-o" size="32" color="#999" />
          <span>暂无营业执照</span>
        </div>
      </div>

      <!-- 无数据提示 -->
      <div v-if="!loading && !info.enterpriseName" class="empty-state">
        <van-icon name="info-o" size="48" color="#999" />
        <div class="empty-text">暂无企业信息</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Qyxx',
  data() {
    return {
      loading: true,
      info: {},
      licenseFiles: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const houseId = sessionStorage.getItem('houseId')
        const res = await this.$axios.get('/api/v1/wygl/property/enterprise', {
          params: { houseId }
        })
        console.log('企业信息接口返回:', res)
        if (res && res.data && res.data.length > 0) {
          this.info = res.data[0]
          console.log('企业信息:', this.info)
          console.log('营业执照附件ID:', this.info.qyfrzzAttach)
          // 处理营业执照附件
          if (this.info.qyfrzzAttach) {
            // 附件ID可能是逗号分隔的多个ID
            const attachIds = this.info.qyfrzzAttach.split(',').filter(id => id.trim())
            console.log('附件ID列表:', attachIds)
            // 构建下载URL列表
            this.licenseFiles = attachIds.map((id, index) => {
              return {
                name: `营业执照${attachIds.length > 1 ? (index + 1) : ''}`,
                url: `/api/v1/common/download/${id.trim()}`
              }
            })
            console.log('营业执照附件列表:', this.licenseFiles)
          }
        }
      } catch (error) {
        console.error('加载企业信息失败:', error)
      } finally {
        this.loading = false
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      if (typeof dateStr === 'string') {
        return dateStr.slice(0, 10)
      }
      return dateStr
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 16px;
}

.loading {
  display: flex;
  justify-content: center;
  padding: 50px 0;
}

.content {
  padding-bottom: 20px;
}

.card {
  background-color: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;

  .label {
    font-size: 14px;
    color: #999;
    flex-shrink: 0;
    width: 80px;
  }

  .value {
    font-size: 14px;
    color: #333;
    text-align: right;
    flex: 1;
    word-break: break-all;
  }
}

.license-card {
  .license-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .license-item {
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 8px;
    text-decoration: none;
    transition: background-color 0.2s;

    &:active {
      background-color: #eef1f5;
    }

    .file-icon {
      width: 40px;
      height: 40px;
      background-color: #e8f4fd;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .file-info {
      flex: 1;
      margin-left: 12px;
      overflow: hidden;

      .file-name {
        font-size: 14px;
        color: #333;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .file-hint {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
      }
    }

    .file-arrow {
      flex-shrink: 0;
      margin-left: 8px;
    }
  }

  .empty-license {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #999;

    span {
      margin-top: 12px;
      font-size: 14px;
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;

  .empty-text {
    font-size: 14px;
    color: #999;
    margin-top: 16px;
  }
}
</style>
